import script from "./RecordingWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecordingWindow.vue?vue&type=script&setup=true&lang=ts"

import "./RecordingWindow.vue?vue&type=style&index=0&id=0bafea30&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bafea30"]])

export default __exports__